import { Car, Bike, Truck, HelpCircle } from "lucide-react";

export default function VehicleSection() {
  return (
    <section className="vehicle-section" id="start" data-testid="vehicle-section">
      <h2>
        If you bought a car on finance between 2007 &ndash; 2024, you may be eligible to receive compensation worth &pound;2,075* for your car finance agreements.
      </h2>
      <div className="vehicle-grid" data-testid="vehicle-grid">
        <a href="/claim" className="vehicle-card" data-testid="vehicle-card-car">
          <Car className="vehicle-icon" size={48} strokeWidth={1.5} />
          <span className="label">Car</span>
        </a>
        <a href="/claim" className="vehicle-card" data-testid="vehicle-card-bike">
          <Bike className="vehicle-icon" size={48} strokeWidth={1.5} />
          <span className="label">Bike</span>
        </a>
        <a href="/claim" className="vehicle-card" data-testid="vehicle-card-van">
          <Truck className="vehicle-icon" size={48} strokeWidth={1.5} />
          <span className="label">Van</span>
        </a>
        <a href="/claim" className="vehicle-card" data-testid="vehicle-card-other">
          <HelpCircle className="vehicle-icon" size={48} strokeWidth={1.5} />
          <span className="label">Other</span>
        </a>
      </div>
      <p className="vehicle-disclaimer">
        <strong>You do not need to use a claims management company to make a claim;</strong> you can do this yourself for free by contacting the car dealership or finance provider and if that is not successful you can complain to the Financial Ombudsman Service.
      </p>
      <a href="https://sa.yoursolicitor.co.uk/claim" className="btn-dark" data-testid="find-agreements-btn" data-ratifi-forward>
        Find my agreements <span className="arrow">&rarr;</span>
      </a>
      <p className="online-note">Application 100% online</p>
    </section>
  );
}
